import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useRealStudents } from "@/hooks/data/useRealStudents";
import { useRealAttendance } from "@/hooks/data/useRealAttendance";
import { useRealSchoolSettings } from "@/hooks/data/useRealSchoolSettings";
import { useStageOrdering as stageOrder } from "@/hooks/settings/useStageOrdering";
import { StudentWithAttendance } from "@/types/attendance";
import {
  getAvailableGrades,
  getAvailableSections,
} from "@/utils/attendanceFilters";
import { filterAndSortStudents } from "@/utils/studentSorting";
import { getStageDisplayName } from "@/utils/attendanceData";
import { dateSplitter } from "@/utils/formatting/deteSplitter";
import { useAuth } from "@/hooks/auth";

export const useSimpleAttendanceState = () => {
  // const { userProfile } = useAuth();
  const [selectedStage, setSelectedStage] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedDate, setSelectedDate] = useState(dateSplitter(new Date()));
  const [studentsWithAttendance, setStudentsWithAttendance] = useState<
    StudentWithAttendance[]
  >([]);

  const { students: realStudents } = useRealStudents();
  const { getStudentAttendance } = useRealAttendance();

  const { settings, loading: settingsLoading } = useRealSchoolSettings();

  // console.log('school settings: ', settings)
  const orderedStages = useMemo(() => {
    if (!settings?.stages) return [];

    // const orderdStgs= stageOrder(settings.stages);

    return settings.stages.filter(
      (stage: any) => stage && stage.enabled === true
    );
  }, [settings?.stages]);

  // تحويل بسيط للطلاب
  const students = useMemo(() => {
    const tempStus = realStudents?.map((student) => ({
      id: student.id,
      name: student.name,
      grade: student.grade,
      section: student.section,
      studentId: student.student_id,
    }));

    return filterAndSortStudents(
      tempStus,
      selectedGrade,
      selectedSection,
      selectedStage,
      // hasMultipleStages,
      orderedStages
    );
  }, [
    orderedStages,
    realStudents,
    selectedGrade,
    selectedSection,
    selectedStage,
  ]);


  const hasMultipleStages = orderedStages?.length > 1;
  const availableGrades = useMemo(() => {
    return getAvailableGrades(
      students,
      orderedStages,
      hasMultipleStages,
      selectedStage,
      orderedStages
    );
  }, [students, orderedStages, hasMultipleStages, selectedStage]);
  const availableSections = useMemo(() => {
    return getAvailableSections(
      selectedGrade,
      students,
      orderedStages,
      hasMultipleStages,
      selectedStage,
      orderedStages
    );
  }, [
    selectedGrade,
    students,
    orderedStages,
    hasMultipleStages,
    selectedStage,
  ]);

  // دوال تغيير الحالة مع إعادة تعيين البيانات المرتبطة
  const handleStageChange = useCallback(
    (stage: string) => {
      // console.log("Stage change requested:", stage, "current:", selectedStage);
      if (stage !== selectedStage) {
        setSelectedStage(stage);
        setSelectedGrade("");
        setSelectedSection("");
        setStudentsWithAttendance([]);
      }
    },
    [selectedStage]
  );

  const handleGradeChange = useCallback(
    (grade: string) => {
      // console.log("Grade change requested:", grade, "current:", selectedGrade);
      if (grade !== selectedGrade) {
        setSelectedGrade(grade);
        setSelectedSection("");
        setStudentsWithAttendance([]);
      }
    },
    [selectedGrade]
  );

  const handleSectionChange = useCallback(
    (section: string) => {
      // console.log(
      //   "Section change requested:",
      //   section,
      //   "current:",
      //   selectedSection
      // );
      if (section !== selectedSection) {
        setSelectedSection(section);
        setStudentsWithAttendance([]);
      }
    },
    [selectedSection]
  );

 
  // إضافة دالة لإعادة تحميل البيانات فوراً
  // console.log("avaialables sections: ", availableSections);
  // console.log("hasMultipleStages: ", hasMultipleStages);
  // console.log("orderedStages: ", orderedStages);
  // console.log("students: ", students);
  return {
    selectedStage,
    selectedGrade,
    selectedSection,
    selectedDate,
    studentsWithAttendance: students,
    enabledStages: orderedStages,
    hasMultipleStages,
    availableGrades,
    availableSections,
    settings,
    students,
    loading: settingsLoading,
    setSelectedStage: handleStageChange,
    setSelectedGrade: handleGradeChange,
    setSelectedSection: handleSectionChange,
    setSelectedDate,
    getStageDisplayName,
    orderedStages,
    // refreshData,
  };
};
